import React from 'react';
import { Pressable, PressableProps, View } from 'react-native';

import { ButtonProps } from '.';

import { getIconByName } from 'components/Icons';

type CleanButtonProps = Omit<ButtonProps, 'gradientVariant' | 'variant' | 'backgroundColor'>;

const CleanButton = React.forwardRef<PressableProps, CleanButtonProps>(
  (
    {
      children,
      iconStyle,
      iconType,
      isFullWidth = false,
      isLoading = false,
      size = 'md',
      textStyle,
      textTransform,
      rounded = false,
      ...rest
    },
    ref
  ) => {
    const Icon = iconType ? getIconByName(iconType) : null;

    return (
      <Pressable
        ref={ref}
        style={{
          backgroundColor: 'transparent',
          width: isFullWidth ? '100%' : undefined,
          flexDirection: 'row',
          alignItems: 'center',
        }}
        {...rest}>
        {Icon && (
          <View style={{ marginRight: 4 }}>
            <Icon {...iconStyle} />
          </View>
        )}
        {children}
      </Pressable>
    );
  }
);

export default CleanButton;
